<script setup>
/**
 * Batch Upload Emergenetics — uploads one or more PDF/image files, each
 * converted to a stored PNG via /api/pdftoimage. Mirrors Vue2's
 * Psychometrics/Emergenetics.vue (fire-and-forget per file, same as legacy).
 */
import { ref } from "vue";
import { useRouter } from "vue-router";
import { uploadEmergeneticsPdf } from "./api";

const router = useRouter();
const fileNames = ref([]), loading = ref(false), success = ref(false), error = ref("");

async function onFiles(e) {
  const files = Array.from(e.target.files || []); e.target.value = "";
  if (!files.length) return;
  fileNames.value = files.map(f => f.name);
  loading.value = true; error.value = ""; success.value = false;
  try {
    await Promise.all(files.map(uploadEmergeneticsPdf));
    success.value = true;
  } catch { error.value = "Error occurred. Please try again."; }
  finally { loading.value = false; }
}
</script>

<template>
  <section>
    <VBtn variant="text" prepend-icon="mdi:arrow-left" class="mb-4" @click="router.push({ name: 'users' })">Back</VBtn>
    <h1 class="text-h5 mb-4">Batch Upload Emergenetics</h1>
    <VCard class="pa-4" max-width="560">
      <VAlert v-if="error" type="error" class="mb-4">{{ error }}</VAlert>
      <VAlert v-if="success" type="success" class="mb-4">Batch add/update successful.</VAlert>
      <div class="mb-4">
        <div class="text-body-2 font-weight-semibold mb-1">Upload PDF File/Image</div>
        <input type="file" accept="application/pdf" multiple :disabled="loading" @change="onFiles" />
        <p v-if="fileNames.length" class="text-caption text-medium-emphasis mt-1">{{ fileNames.join(", ") }}</p>
      </div>
    </VCard>
  </section>
</template>
